// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::-webkit-scrollbar {\n  width: 2px;\n}\n::-webkit-scrollbar-thumb {\n  /* remove scrollbar space */\n  background-color: var(--v-primary-base);\n  border-radius: 10px;\n  /* optional: just make scrollbar invisible */\n}\n.theme--dark.v-application {\n  background-color: var(--v-background-base, #121212) !important;\n}\n.theme--light.v-application {\n  background-color: var(--v-background-base, white) !important;\n}", ""]);
// Exports
module.exports = exports;
